<template>
  <div id="app">
    <header>
      <div class="logo">
        <router-link to="/" @click.native="add_Tags(tags.index,'gotoPage','#home',null)"><img
            src="@/assets/img/logo.png"></router-link>
      </div>
      <nav id="menu_list" v-if="navList">
        <ul>
          <li @click="nav(false)">
            <router-link to="/" @click.native="add_Tags(tags.index,'gotoPage','#home',null)">首頁</router-link>
          </li>
          <li @click="nav(false)">
            <router-link to="/" @click.native="add_Tags(tags.conduct,'gotoPage','#conduct',null)">溫柔進行式</router-link>
          </li>
          <li @click="nav(false)">
            <router-link to="/listPage" @click.native="add_Tags(tags.list,null,null ,null)">大眾的溫柔</router-link>
          </li>
          <li @click="nav(false)">
            <router-link to="/" @click.native="add_Tags(tags.GentleCarbon,'gotoPage','#GentleCarbon',null)">溫柔碳足跡
            </router-link>
          </li>
          <li @click="nav(false)">
            <router-link to="/method" @click.native="add_Tags(tags.method,null,null,null)">徵件辦法</router-link>
          </li>
          <!-- <li @click="nav(false)" v-if="new Date()< new Date(this.$store.state.signDeadline)">
            <router-link to="/detail?obj=signPage" @click.native="add_Tags(tags.detail,null,null, null)">立即報名
            </router-link>
          </li> -->
          <li @click="nav(false)">
            <router-link to="/winning">得獎名單</router-link>
          </li>
          <img src="@/assets/img/navImg.png">
        </ul>
      </nav>
      <button @click="nav(true)" :class="{active:navList}" id="menu_button_wrapper">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </header>
    <article>
      <router-view :url-query="urlQuery" :access-token="accessToken" :apiUrl="apiUrl" :oaUrl="oaUrl"
        @addTags="add_Tags" />
        <fixBTComponents @addTags="add_Tags" v-if="!navList"></fixBTComponents>
    </article>
    <popup @addTags="add_Tags" :popupLocation="popupLocation" v-if="showPopup" @popupStatus="seePopup"/>
  </div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/axios/0.18.0/axios.js"></script>
<script>
 import fixBTComponents from '@/components/fixBTComponents.vue';
  import axios from 'axios'
  import popup from '@/components/popup.vue';
  import liff from '@line/liff';
  import swal from 'sweetalert2';

  export default {
    components: {
      popup,
      fixBTComponents,
    },
    data() {
      return {
        popupLocation: "linePopup",
        accessToken: '', //取得Line Token
        lineProfile: '', //取得user資訊
        showPopup: false,
        navList: false,
        urlQuery: {},
        obj: {},
        apiUrl: process.env.NODE_ENV != 'production' ? "https://hulk.iprefer.com.tw/clc/a22_clc_andante_cothink/" :
          "https://promo.andante-event.com.tw/sharing/",
        tags: {
          index: 'D002F733301543EBB8B170FAF0A8DE75',
          conduct: '139EF36892584C49A5C61B8FC9546B55',
          list: '1921D696DC0E4E3F85D7E5515312DFD0',
          GentleCarbon: 'A7EDF79204E64F40AD3A47616DBEE77A',
          method: '651DDCFEBA724EE8B810CB393FBB7AA8',
          detail: 'F9B7DF0D26CA46719D6614958444499A',
          goToListPage: '35283B5FC668488BA694DCCAA0515860'
        },
        oaUrl: null
      }
    },
    beforeDestroy() {
      // 移除 監聽
      window.addEventListener("resize", this.renderResize, false);
    },
    methods: {
      renderResize() {
        if (window.orientation == 180 || window.orientation == 0) {
          this.showPopup = false
        }
        if (window.orientation == 90 || window.orientation == -90) {
          this.showPopup = true
        }
      },
      nav(val) {
        if (val) {
          this.navList = !this.navList
        } else(
          this.navList = false
        )
      },
      gotoPage(path) {
        if (path.indexOf("#") != -1) {
          if (path == '#home') {
            window.scroll(52, 0);
          } else {
            this.$router.push(path).catch(error => {
              if (error.name !== 'NavigationDuplicated' && !error.message.includes(
                  'Avoided redundant navigation to current location')) {
                console.log(error)
              };
            });
            document.getElementById(path.replace('#', '')).scrollIntoView();
          }
        } else {
          this.$router.push(path).catch(error => {
            if (error.name !== 'NavigationDuplicated' && !error.message.includes(
                'Avoided redundant navigation to current location')) {
              console.log(error)
            };
          })
        }
      },
      add_Tags(tag, methodName, methodData, page) {
        var me = this;
        var config = {
          method: "post",
          url: me.apiUrl + "Liff/AddData_AddAccuNixTags/80738C659D3041A79143420D6BD46C7A",
          headers: {
            "Authorization": `Bearer ${me.accessToken}`,
            "content-type": "application/json"
          },
          data: new FormData()
        }
        config.data.append('tag', tag);

        axios(config).then(res => {}).catch((error) => {});

        if (methodName) {
          me.$childMethod.$emit(methodName, methodData);
        }
        // 執行SPA相關動作
        if (page) {
          var path = page.path;
          var query = page.query;
          if (path) {
            if (query) {
              this.$router.push({
                path: path,
                query: query
              }).catch(error => {
                if (error.name !== 'NavigationDuplicated' && !error.message.includes(
                    'Avoided redundant navigation to current location')) {
                  console.log(error)
                };
              });
            } else {
              this.$router.push({
                path: path
              });
            }
          }
        }
      },
      gtag_trackEvent(category, action, label) {
        if (typeof gtag !== 'undefined') {
          gtag('event', action, {
            'event_category': category,
            'event_label': label
          });
        }
      },
    },
    watch: {
      '$route.query': {
        handler: function (newVal, oldVal) {
          this.urlQuery = newVal;
        },
        deep: true,
        immediate: true
      }
    },
    created: function () {
      this.$childMethod.$on('gotoPage', this.gotoPage);
    },
    mounted: function () {
      var liffId = /(192.168|localhost)/.test(window.location.href) ? "1656433734-x58meKe8" : process.env.NODE_ENV ==
        'production' ? "1655166006-M5NZ0DYN" : "1656433734-grWMX4XW";

      let _this = this;
      liff.init({
        liffId: liffId,
        withLoginOnExternalBrowser: true
      }).then(() => {
        //確認登入狀態
        if (!liff.isLoggedIn()) {
          //執行登入
          liff.login({
            redirectUri: location.href
          });
        } else {
          //確認好友狀態
          liff.getFriendship().then(async (data) => {
            if (!data.friendFlag) {
              swal.fire({
                text: '請加入春風官方帳號好友',
                allowOutsideClick: false
              }).then(() => {
                var isDev = /(192.168|localhost|thor.iprefer|hulk.iprefer)/.test(window.location.href);
                window.location.href = isDev ? 'https://line.me/R/ti/p/@374zoemd' :
                  'https://line.me/R/ti/p/@andantetissue';
              })
              _this.showPopup = true
              // 做一個popup，有顆按鈕可以導到加好友畫面
            } else {
              try {
                //取得Line Token
                _this.accessToken = liff.getAccessToken();
                //取得user資訊
                _this.lineProfile = await liff.getProfile();

                // console.log("lineProfile,accessToken",lineProfile,accessToken)

                if (this.accessToken && this.lineProfile) {
                  gtag('set', 'dimension1', this.lineProfile.userId);
                  gtag('set', {
                    'user_id': this.lineProfile.userId
                  });
                }
              } catch (error) {
                alert('忙碌中，請稍後再試');
                console.error(error);
              }
            }
          });
        }
      }).catch(error => {
        alert(error);
      });
      window.addEventListener("resize", this.renderResize, true);
    },
    destroyed: function () {
      this.$childMethod.$off('gotoPage');
    }
  }
</script>
<style lang="scss">
  @import "@/assets/scss/all";
</style>